// extracted by mini-css-extract-plugin
module.exports = {"detailItem":"DetailItem_detailItem__2CgMF","label":"DetailItem_label__AgD0L","emptyValue":"DetailItem_emptyValue__1UCtl","value":"DetailItem_value__2ZGgf"};